import { createStore } from "vuex";
import appModule from "./modules/appModule";
import authModule from "./modules/authenticationModule";

const store = createStore({
  modules: {
    appModule,
    authModule,
  },
});

export default store;
